/* unplugin-vue-components disabled */import { render } from "./AsideMenu.vue?vue&type=template&id=f4b20b28&scoped=true"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"

import "./AsideMenu.vue?vue&type=style&index=0&id=f4b20b28&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b20b28"]])

export default __exports__